<div class="middle-box text-center lockscreen animated fadeInDown">
    <form action="/User4iLogin/Login"
          id="login_form"
          class="login-form"
          method="post"
          novalidate="novalidate">
        <div [style.display]="showLoginForm ? 'block' : 'none'">
            <div class="validation-summary-valid text-danger"
                 data-valmsg-summary="true">
                <ul>
                    <li style="display: none"></li>
                </ul>
            </div>
            <h2 class="header-text">{{ 'Pages.Login.HeaderText' | translate }}</h2>
            <hr />

            <div #errorElement
                 class="alert alert-danger small fadeInDown"
                 *ngIf="errorValue">
                {{errorValue}}
            </div>

            <div class="m-t" role="form" action="index.html" id="page-login-form">
                <div class="form-group">
                    <!--                    {{ 'Pages.Login.DescriptionText' | translate }}-->
                </div>
                <div class="form-group">
                    <input class="form-control"
                           name="login"
                           type="text"
                           placeholder="{{ 'Pages.Login.EmailPlaceholder' | translate }}"
                           data-val="true"
                           aria-required="true"
                           [textMask]="{mask: emailMask}"
                           [(ngModel)]="loginValue" />
                </div>
                <div class="form-group">
                    <input class="form-control"
                           name="Password"
                           type="password"
                           placeholder="{{ 'Pages.Login.PasswordPlaceholder' | translate }}"
                           autocomplete="current-password"
                           data-val="true"
                           aria-required="true"
                           (change)="passwordValueChanged()"
                           (focus)="passwordElementOnFocus()"
                           [(ngModel)]="passwordValue" />
                </div>

                <div class="form-group" *ngIf="showCaptcha">

                    <app-captcha #captchaComponent></app-captcha>
                    <input id="captchaCode"
                           name="captchaCode"
                           [(ngModel)]="captchaCode"
                           class="form-control"
                           autocomplete="off"
                           placeholder="{{ 'Common.CaptchaText' | translate }}"
                           type="text">
                </div>

                <div class="form-group">

                    <button type="submit"
                            class="btn btn-primary block full-width"
                            [disabled]="loginValue?.length < 5 || passwordValue?.length < 4 || loginRequestSending"
                            (click)="doLogin($event)">
                        {{ 'Pages.Login.LoginButtonText' | translate }}
                    </button>

                    <button (click)="restorePasswordOpenDialog()" class="btn btn-primary block full-width">
                        {{ 'Pages.Login.GetPasswordButtonText' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div [style.display]="showLoginForm ? 'none' : 'block'">{{ 'Pages.Login.Welcome' | translate }}</div>
    </form>
</div>
